import { AccountReceivableModel } from 'api-hooks/account-receivable';
import { ReceiptModel } from 'api-hooks/receipt';
import React from 'react';

import { FormType } from '../components/form-type';

interface Props {
  accountReceivable?: AccountReceivableModel;
  receiptData?: ReceiptModel;
}

export default function useGetDefaultValues(props: Props) {
  const { accountReceivable, receiptData } = props;
  const defaultValues = React.useMemo<FormType>(() => {
    if (receiptData) {
      return {
        chequeNote: null,
        customerId: receiptData.customer.id,
        description: receiptData.description || '',
        refId: undefined,
        number: '',
        paymentableId: null,
        paymentItems: [],
        paymentMethodId: null,
        paymentMehtod: '',
        transactionAt: new Date(),
        tempTransactionAt: new Date(),
        needApproval: false,
      };
    }
    return {
      chequeNote: accountReceivable?.payment.chequeNote
        ? {
            availableAt: accountReceivable.payment.chequeNote.availableAt,
            bankAccountId: accountReceivable.payment.chequeNote.bankAccount.id,
            chequeGiroId: accountReceivable.payment.chequeNote.chequeGiro.id,
            expiredAt: accountReceivable.payment.chequeNote.expiredAt,
            issuedAt: accountReceivable.payment.chequeNote.issuedAt,
            referenceNumber:
              accountReceivable.payment.chequeNote.referenceNumber,
          }
        : null,
      customerId: accountReceivable?.customer.id ?? null,
      description: accountReceivable?.description ?? '',
      refId: accountReceivable?.refId,
      number: accountReceivable?.number ?? '',
      paymentableId: accountReceivable?.payment?.chequeNote?.id
        ? accountReceivable.payment.chequeNote.chequeGiro.id
        : accountReceivable?.payment.paymentable?.id
        ? accountReceivable.payment.paymentable.id
        : null,
      paymentItems: accountReceivable?.payment.paymentItems
        ? accountReceivable.payment.paymentItems.map((item) => ({
            isCheck: true,
            amount: item.amount,
            discount: item.discount,
            fee: item.fee,
            paidAmount: item.transactionable.paidAmount,
            saleId: item.transactionable.id,
            tax: item.tax,
            total: item.transactionable.total,
            invoiceNumber: item.transactionable.number,
            status: item.transactionable.status,
            saleRefId: item.transactionable.refId,
            dueAmount:
              item.transactionable.total - item.transactionable.paidAmount,
            billingTo: item.transactionable.billingTo,
            dueDate: item.transactionable.dueDate,
            acl: item.transactionable.acl,
          }))
        : [],
      paymentMethodId: accountReceivable?.payment.paymentMethod.id ?? null,
      paymentMethod: accountReceivable?.payment.paymentMethod.type ?? '',
      transactionAt: accountReceivable?.transactionAt ?? new Date(),
      tempTransactionAt: accountReceivable?.transactionAt ?? new Date(),
      needApproval: false,
    };
  }, [accountReceivable, receiptData]);

  return defaultValues;
}
